"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StringFilter = function StringFilter(_ref) {
  var className = _ref.className,
      value = _ref.value,
      icon = _ref.icon,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      clearButton = _ref.clearButton,
      debounceTime = _ref.debounceTime,
      disabled = _ref.disabled,
      onChange = _ref.onChange;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var debouncedValue = (0, _hooks.useDebounce)(inputValue, debounceTime);
  var prevDebouncedValue = (0, _hooks.usePrevious)(debouncedValue);
  var prevValue = (0, _hooks.usePrevious)(value); // update input value if props have changed

  (0, _hooks.useDidUpdate)(function () {
    if (!isFocused && prevValue !== value && inputValue !== value) {
      setInputValue(value);
    }
  }, [inputValue, isFocused, prevValue, value]); // call onChange if debounced input value has changed

  (0, _hooks.useDidUpdate)(function () {
    if (debouncedValue !== prevDebouncedValue && debouncedValue !== value) {
      onChange(debouncedValue);
    }
  }, [debouncedValue, onChange, prevDebouncedValue, value]);

  var onInputValueChange = function onInputValueChange(newValue) {
    if (!disabled) {
      setInputValue(newValue || null);
    }
  };

  var onInputValueClear = function onInputValueClear() {
    if (!disabled) {
      setInputValue(null);
      onChange(null);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative flex items-center gap-1', className)
  }, icon, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    label: label,
    hideLabel: hideLabel,
    value: inputValue || '',
    onChange: onInputValueChange,
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    disabled: disabled,
    className: "flex-1",
    style: {
      paddingRight: 28
    }
  }), clearButton && inputValue !== null && !disabled ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "absolute right-0 transform -translate-x-1 cursor-pointer",
    title: intl.formatMessage({
      id: 'filters.reset'
    }),
    onClick: onInputValueClear
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Clear, {
    className: "w-4 h-4 fill-primary transform transition duration-400 ease-in-out hover:scale-120"
  })) : null);
};

StringFilter.propTypes = {
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  label: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  clearButton: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  debounceTime: _propTypes["default"].number
};
StringFilter.defaultProps = {
  className: '',
  onChange: function onChange() {},
  disabled: false,
  icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Magnifier, null),
  label: '',
  hideLabel: false,
  clearButton: true,
  value: null,
  debounceTime: 400
};
var _default = StringFilter;
exports["default"] = _default;